import type {CallChangeKind} from "./callChangesRequest";

export const CALL_CHANGES_WAIT_SECONDS = 25;
export const CALL_CHANGES_FALLBACK_POLL_MS = 60_000;
export const CALL_CHANGES_DISABLED_RECHECK_MS = 60_000;
export const CALL_CHANGES_IDLE_GAP_MS = 500;
export const CALL_CHANGES_FAILURES_BEFORE_FALLBACK = 3;

const RETRY_DELAYS_MS = [1_000, 2_000, 5_000, 10_000, 30_000] as const;

export const getCallChangesRetryDelay = (failureCount: number): number =>
    RETRY_DELAYS_MS[Math.min(Math.max(failureCount, 1), RETRY_DELAYS_MS.length) - 1];

export const callChangeTags = (changed: readonly CallChangeKind[]) =>
    changed.map((kind) => ({type: 'Calls' as const, id: kind}));

export const callsPollingInterval = (live: boolean, legacyIntervalMs: number): number =>
    live ? Math.max(legacyIntervalMs, CALL_CHANGES_FALLBACK_POLL_MS) : legacyIntervalMs;
